import './index.css';
import React from 'react';
import cn from 'classnames';
import { ThemeProvider } from '@rescui/ui-contexts';
import { useTextStyles } from '@rescui/typography';
import styles from './cta-block.module.pcss.js';

function Cta({
  className,
  classTopTitle,
  topTitle,
  classMainTitle,
  mainTitle,
  classContent,
  children,
  classButtons,
  buttons
}) {
  const textCn = useTextStyles();
  return React.createElement("div", {
    className: cn(className, styles.wrapper)
  }, React.createElement("div", {
    className: cn(styles.layout, 'ktl-layout ktl-layout--center')
  }, topTitle && React.createElement("div", {
    className: cn(classTopTitle, styles.topTitle, textCn('rs-text-2', {
      hardness: 'hard'
    }))
  }, topTitle), React.createElement("h2", {
    className: cn(classMainTitle, styles.mainTitle, textCn('rs-h2'))
  }, mainTitle), children && React.createElement("div", {
    className: cn(classContent, styles.content)
  }, children), buttons && React.createElement("div", {
    className: cn(classButtons, styles.buttons)
  }, buttons)));
}

function CtaBlock({
  theme,
  ...props
}) {
  return React.createElement(ThemeProvider, {
    theme: theme || 'dark'
  }, React.createElement(Cta, { ...props
  }));
}

export { CtaBlock };
